/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'

const useTimeKeyInterval = ( secondsInterval = 30 ) => {
  const [ timeKey, setTimeKey ] = useState( Date.now() )
  const timerId = useRef()
  
  useEffect( () => {
    const load = () => {
      setTimeout( () => {
        setTimeKey( Date.now() )
        load()
      }, secondsInterval * 1000 )
    }
    load()

    return () => {
      if ( timerId.current ) {
        clearTimeout( timerId.current )
      }
    }
  }, [] )

  return {
    timeKey
  }
}

export default useTimeKeyInterval
